import axios from 'axios';
interface ErrorLogPayload {
  module: string;
  action: string;
  error: string;
  stack?: string;
  metadata?: Record<string, any>;
}
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
if (!BASE_URL) {
  console.warn('[ErrorLogger] BASE_URL 未定义，请检查环境变量 REACT_APP_API_BASE_URL');
}
export const logErrorToServer = async (payload: ErrorLogPayload) => {
  if (!BASE_URL) {
    console.warn('[ErrorLogger] BASE_URL 未定义，日志不上报');
    return;
  }
  const url = `${BASE_URL}/api/ClientError`;
  console.log('[ErrorLogger] 上报地址:', url);
  try {
    await axios.post(url, {
      ...payload,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      route: window.location.pathname,
      env: process.env.NODE_ENV
    });
  } catch (e) {
    console.warn('[ErrorLogger] 日志上报失败:', e);
    if ('localStorage' in window) {
      const failedLogs = JSON.parse(localStorage.getItem('failedErrorLogs') || '[]');
      localStorage.setItem('failedErrorLogs', JSON.stringify([...failedLogs, payload]));
    }
  }
};
export const setupGlobalErrorHandling = () => {
  // 未捕获的异常
  window.addEventListener('error', (event) => {
    const payload = {
      module: 'Global',
      action: 'unhandled-error',
      error: event.message,
      stack: event.error?.stack,
      metadata: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno
      }
    };
    logErrorToServer(payload);
  });
  // Promise rejection
  window.addEventListener('unhandledrejection', (event) => {
    logErrorToServer({
      module: 'Global',
      action: 'unhandled-rejection',
      error: event.reason?.message || String(event.reason),
      stack: event.reason?.stack
    });
  });
};
// 重试失败日志
export const retryFailedLogs = async () => {
  if (!('localStorage' in window)) return;
  const failedLogs = JSON.parse(localStorage.getItem('failedErrorLogs') || '[]');
  if (failedLogs.length > 0) {
    await Promise.allSettled(failedLogs.map(logErrorToServer));
    localStorage.removeItem('failedErrorLogs');
  }
};